/**
 * @author Ivan Toth.
 */
var treeEditBind = {
    item: '=',
    caller: '=',
    level: '=',
    parent: '='
};
var DetailTreeEditController = (function () {
    function DetailTreeEditController(topic, socket, env, $scope, Dialog, settings) {
        this.topic = topic;
        this.socket = socket;
        this.env = env;
        this.$scope = $scope;
        this.Dialog = Dialog;
        this.settings = settings;
        this.defaultState = true;
        this.visible = true;
        this.OPP_VERSION_3 = 3;
        this.OPP_VERSION_4 = 4;
        this.excludeCountries = [
            'JP',
            'CN',
            'TW',
            'HK',
            'BR',
            'AF',
            'AU',
            'BN',
            'KH',
            'FJ',
            'PH',
            'BT',
            'SG',
            'SB',
            'LA',
            'TL',
            'IN',
            'ID',
            'PG',
            'LK',
            'AS',
            'KR',
            'KP',
            'VN',
            'BD',
            'MY',
            'MV',
            'NZ',
            'TH',
            'WS',
        ];
        this.compId = DetailTreeEditController.generateId();
        //this.validate();
        return;
    }
    DetailTreeEditController.generateId = function () {
        DetailTreeEditController.uniqueId++;
        return DetailTreeEditController.uniqueId;
    };
    DetailTreeEditController.prototype.toggle = function () {
        this.visible = !this.visible;
    };
    DetailTreeEditController.prototype.rbr = function (v) {
        if (angular.isDefined(v)) {
            return v.replace(/<br>/g, '\n');
        }
    };
    DetailTreeEditController.prototype.parseSAPAmount = function (amount) {
        try {
            amount = String(amount).trim();
            if (amount.includes('.') && amount.includes(',')) {
                return amount.lastIndexOf('.') > amount.lastIndexOf(',')
                    ? Number(amount.split(',').join(''))
                    : Number(amount.split('.').join('').replace(',', '.'));
            }
            if (amount.includes('.')) {
                var parts = amount.split('.');
                return parts[parts.length - 1].length === 3
                    ? Number(parts.join(''))
                    : Number(amount);
            }
            if (amount.includes(',')) {
                var parts = amount.split(',');
                return parts[parts.length - 1].length === 3
                    ? Number(parts.join(''))
                    : Number(amount.replace(',', '.'));
            }
            return Number(amount);
        }
        catch (e) {
            return NaN;
        }
    };
    DetailTreeEditController.prototype.addChild = function () {
        this.topic.temp.calculation.recalculated = false;
        var obj = this.item;
        var level = this.level;
        while (level < this.settings.calculationTreeLevels.length - 1) {
            if (level === 3) {
                obj.children.unshift({
                    id: '',
                    bonus: null,
                    bonusSolution: null,
                    bonusNewClient: null,
                    bonusFocus: null,
                    bonusGrowth: null,
                    bonusCtl: null,
                    children: [],
                    createdManual: true
                });
            }
            else {
                obj.children.unshift({
                    id: '',
                    children: []
                });
            }
            level++;
            obj = obj.children[0];
        }
        obj.children = undefined;
    };
    DetailTreeEditController.prototype.remove = function () {
        this.topic.temp.calculation.recalculated = false;
        for (var i = 0; i < this.parent.item.children.length; i++) {
            if (this.parent.item.children[i] === this.item) {
                this.parent.item.children.splice(i, 1);
                break;
            }
        }
        if (this.level > 0) {
            if (this.parent.item.children.length < 1) {
                this.parent.remove();
            }
        }
        this.validate();
    };
    DetailTreeEditController.prototype.updateVal = function () {
        this.topic.temp.calculation.recalculated = false;
        this.validate();
    };
    DetailTreeEditController.prototype.validate = function () {
        this.topic.temp.calculation.recalculated = false;
        /*		if (this.caller === 'payment') {
            this.validateCalculation();
        }
*/
    };
    DetailTreeEditController.prototype.validateCalculation = function () {
        var _this = this;
        this.item.error = '';
        if (isNaN(this.level)) {
            this.item.error = "Invalid tree level.";
        }
        if (!this.item.id) {
            this.item.error = this.settings.calculationTreeLevels[this.level] + " must not be empty.";
        }
        if (this.level > 0) {
            var count_1 = 0;
            this.parent.item.children.forEach(function (item) {
                if (item.id === _this.item.id) {
                    count_1++;
                }
            });
            if (count_1 > 1) {
                this.item.error += "Duplicate " + this.settings.calculationTreeLevels[this.level];
            }
        }
        if (this.level === 4) {
            if (isNaN(this.item.amountLC)) {
                this.item.error = 'Invalid SO amount.';
            }
        }
    };
    DetailTreeEditController.prototype.changeUplift = function (event) {
        var _this = this;
        var errMessGPP = 'One or more values are invalid. The Uplift Opportunity % must be between 1 and 1000 or N/A, and the Comments are mandatory';
        var errMessSO = 'One or more values are invalid. The Uplift Sales Order % must be between 1 and 100 or N/A, and the Comments are mandatory';
        var items;
        items = {
            type: 'Uplift',
            upliftTypes: ['Opportunity', 'Sales Order']
        };
        this.Dialog.updateValidForm(event, items, 'dialog-uplift-bonus.html').then(function (dResult) {
            _this.topic.temp.calculation.recalculated = false;
            if (dResult.upliftType === 'Opportunity') {
                if (!_this.validateBU(dResult.value, dResult.comments, "GPP")) {
                    var items2 = {
                        icon: 'ERROR',
                        message: errMessGPP,
                        title: 'Saving Error'
                    };
                    _this.Dialog.updateValidForm(undefined, items2, 'confirm-prompt.html').then(function (dResult) {
                        return;
                    });
                    return;
                }
            }
            if (dResult.upliftType === "Sales Order") {
                if (!_this.validateBU(dResult.value, dResult.comments, "SO")) {
                    var items2 = {
                        icon: 'ERROR',
                        message: errMessSO,
                        title: 'Saving Error'
                    };
                    _this.Dialog.updateValidForm(undefined, items2, 'confirm-prompt.html').then(function (dResult) {
                        return;
                    });
                    return;
                }
            }
            if (dResult.upliftType === 'Opportunity') {
                _this.item.autoUplift = false;
                _this.item.uplift = Math.round(dResult.value * 100) / 100;
                _this.item.upliftComments = dResult.comments;
            }
            else {
                _this.item.autoUpliftSo = false;
                _this.item.upliftSo = Math.round(dResult.value * 100) / 100;
                _this.item.upliftSoComments = dResult.comments;
            }
            return;
        });
    };
    DetailTreeEditController.prototype.changeBonus = function (event) {
        var _this = this;
        var it = {};
        it.ssa = angular.isDefined(this.item.bonus);
        it.solution = angular.isDefined(this.item.bonusSolution);
        it.newclient = angular.isDefined(this.item.bonusNewClient);
        it.focus = angular.isDefined(this.item.bonusFocus);
        it.growth = angular.isDefined(this.item.bonusGrowth);
        it.ctl = angular.isDefined(this.item.bonusCtl);
        var errMess = 'One or more values are invalid. The Bonus % must be between 1 and 100 or N/A, and the Comments are mandatory';
        var bonusLabel = 'CVR SSA';
        var bonusSolutionLabel = 'CVR Solution';
        if (this.topic.topic.version && this.topic.topic.version >= 4) {
            bonusLabel = 'SSA';
            bonusSolutionLabel = 'Engagement';
        }
        var items;
        items = {
            type: 'Bonus',
            bonuses: {
                bonus: bonusLabel,
                bonusSolution: bonusSolutionLabel,
                bonusNewClient: 'CVR New Client',
                bonusGrowth: 'Growth',
                bonusFocus: 'Focus',
                bonusCtl: 'Ctl'
            },
            item: this.item,
            valueBonus: this.item.bonus,
            valueSolution: this.item.bonusSolution,
            valueNewClient: this.item.bonusNewClient,
            valueGrowth: this.item.bonusGrowth,
            valueFocus: this.item.bonusFocus,
            valueCtl: this.item.bonusCtl,
            commentsBonus: this.item.bonusComments,
            commentsSolution: this.item.bonusSolutionComments,
            commentsNewClient: this.item.bonusNewClientComments,
            commentsGrowth: this.item.bonusGrowthComments,
            commentsFocus: this.item.bonusFocusComments,
            commentsCtl: this.item.bonusCtlComments
        };
        this.Dialog.updateValidForm(event, items, 'dialog-uplift-bonus.html').then(function (dResult) {
            _this.topic.temp.calculation.recalculated = false;
            // If input not valid for some reason
            if ((it.ssa &&
                !_this.validateBU(dResult.valueBonus, dResult.commentsBonus)) ||
                (it.solution &&
                    !_this.validateBU(dResult.valueSolution, dResult.commentsSolution)) ||
                (it.newclient &&
                    !_this.validateBU(dResult.valueNewClient, dResult.commentsNewClient)) ||
                (it.growth &&
                    !_this.validateBU(dResult.valueGrowth, dResult.commentsGrowth)) ||
                (it.ctl &&
                    !_this.validateBU(dResult.valueCtl, dResult.commentsCtl)) ||
                (it.focus &&
                    !_this.validateBU(dResult.valueFocus, dResult.commentsFocus))) {
                var items2 = {
                    icon: 'ERROR',
                    message: errMess,
                    title: 'Saving Error'
                };
                _this.Dialog.updateValidForm(undefined, items2, 'confirm-prompt.html').then(function (dResult) {
                    return;
                });
                return;
            } /*
            if ((isNaN(Number(dResult.valueBonus)) && its.ssa && dResult.valueBonus !== 'N/A')
                || (isNaN(Number(dResult.valueSolution)) && its.solution && dResult.valueSolution !== 'N/A')
                || (isNaN(Number(dResult.valueNewClient)) && its.newclient && dResult.valueNewClient !== 'N/A')) {
                let items2: any = {
                    icon: 'ERROR',
                    message: errMess,
                    title: 'Saving Error',
                };
                this.Dialog.updateValidForm(undefined, items2, 'confirm-prompt.html').then((dResult) => { return; });
                return;
            }*/
            if (dResult.valueBonus === 'N/A') {
                dResult.valueBonus = undefined;
            }
            if (dResult.valueSolution === 'N/A') {
                dResult.valueSolution = undefined;
            }
            if (dResult.valueNewClient === 'N/A') {
                dResult.valueNewClient = undefined;
            }
            if (dResult.valueGrowth === 'N/A') {
                dResult.valueGrowth = undefined;
            }
            if (dResult.valueFocus === 'N/A') {
                dResult.valueFocus = undefined;
            }
            if (dResult.valueCtl === 'N/A') {
                dResult.valueCtl = undefined;
            }
            if (dResult.commentsBonus === 'N/A') {
                dResult.commentsBonus = undefined;
            }
            if (dResult.commentsSolution === 'N/A') {
                dResult.commentsSolution = undefined;
            }
            if (dResult.commentsNewClient === 'N/A') {
                dResult.commentsNewClient = undefined;
            }
            if (dResult.commentsGrowth === 'N/A') {
                dResult.commentsGrowth = undefined;
            }
            if (dResult.commentsFocus === 'N/A') {
                dResult.commentsFocus = undefined;
            }
            if (dResult.commentsCtl === 'N/A') {
                dResult.commentsCtl = undefined;
            }
            _this.item.autoBonus = false;
            _this.item.bonus = dResult.valueBonus;
            _this.item.bonusComments = dResult.commentsBonus;
            _this.item.bonusSolution = dResult.valueSolution;
            _this.item.bonusSolutionComments = dResult.commentsSolution;
            _this.item.bonusNewClient = dResult.valueNewClient;
            _this.item.bonusNewClientComments = dResult.commentsNewClient;
            _this.item.bonusGrowth = dResult.valueGrowth;
            _this.item.bonusGrowthComments = dResult.commentsGrowth;
            _this.item.bonusFocus = dResult.valueFocus;
            _this.item.bonusFocusComments = dResult.commentsFocus;
            _this.item.bonusCtl = dResult.valueCtl;
            _this.item.bonusCtlComments = dResult.commentsCtl;
            return;
        });
    };
    DetailTreeEditController.prototype.changeForecast = function (event) {
        if (this.topic.checksData.uiVersion >= this.OPP_VERSION_3) {
            this.topic.temp.calculation.forecasts[this.parent.parent.item.drpgId].auto = false;
            this.topic.temp.calculation.forecasts[this.parent.parent.item.drpgId].value = Number(this.topic.temp.calculation.forecasts[this.parent.parent.item.drpgId].value);
            this.topic.temp.calculation = this.changeBFForecast(this.topic.temp.calculation, "drpgId", this.parent.parent.item.drpgId, this.topic.temp.calculation.forecasts[this.parent.parent.item.drpgId].value);
        }
        else {
            this.topic.temp.calculation.forecasts[this.parent.parent.item.brandCode].auto = false;
            this.topic.temp.calculation.forecasts[this.parent.parent.item.brandCode].value = Number(this.topic.temp.calculation.forecasts[this.parent.parent.item.brandCode].value);
            this.topic.temp.calculation = this.changeBFForecast(this.topic.temp.calculation, "brandCode", this.parent.parent.item.brandCode, this.topic.temp.calculation.forecasts[this.parent.parent.item.brandCode].value);
        }
        this.updateVal();
    };
    DetailTreeEditController.prototype.changeBFForecast = function (calc, propertyName, value, newValue) {
        calc.children.forEach(function (orderObject) {
            orderObject.children.forEach(function (bfObject) {
                if (bfObject[propertyName] === value) {
                    bfObject.bfForecast = newValue;
                    bfObject.children.forEach(function (partNumberObject) {
                        partNumberObject.children.forEach(function (lineItemObject) {
                            lineItemObject.bfTotalForecast = newValue;
                        });
                    });
                }
            });
        });
        return calc;
    };
    DetailTreeEditController.prototype.changePayed = function () {
        if (this.topic.checksData.uiVersion >= this.OPP_VERSION_3) {
            this.topic.temp.calculation.payed[this.parent.parent.item.drpgId].auto = false;
            this.topic.temp.calculation.payed[this.parent.parent.item.drpgId].value = Number(this.topic.temp.calculation.payed[this.parent.parent.item.drpgId].value);
        }
        else {
            this.topic.temp.calculation.payed[this.parent.parent.item.brandCode].auto = false;
            this.topic.temp.calculation.payed[this.parent.parent.item.brandCode].value = Number(this.topic.temp.calculation.payed[this.parent.parent.item.brandCode].value);
        }
        this.updateVal();
    };
    DetailTreeEditController.prototype.updateAmount = function () {
        this.item.amountLC = Number(this.item.amountLC);
        this.updateVal();
    };
    DetailTreeEditController.prototype.changeSoAmount = function () {
        this.item.amountLC = Number(this.item.amountLC);
        this.updateVal();
    };
    DetailTreeEditController.prototype.changeBaseAmount = function (val) {
        this.item.baseAmount.amount = Number(val);
        this.updateVal();
    };
    /**
     * Function to validate the user-entered uplift or bonus %
     *
     * @param {*} value
     * @returns {boolean}
     * @memberof DetailTreeEditController
     */
    DetailTreeEditController.prototype.validateBU = function (value, comments, type) {
        // Are the comments there?
        if (angular.isUndefined(comments) || comments.trim() === '') {
            return false;
        }
        var percentage = Number(value); // Convert the value
        // If not a number...
        if (isNaN(percentage)) {
            if (angular.isUndefined(value) || value.toUpperCase() !== 'N/A') {
                return false; // If not N/A...
            }
        }
        else {
            // Is a number
            if (type === "GPP") {
                if (percentage < 0 || percentage > 1000) {
                    return false;
                }
            }
            if (type === "SO") {
                if (percentage < 0 || percentage > 100) {
                    return false;
                }
            }
        }
        return true; // All good
    };
    DetailTreeEditController.$inject = ['topic', 'socket', 'env', '$scope', 'Dialog', 'settings'];
    DetailTreeEditController.uniqueId = 0;
    return DetailTreeEditController;
}());
var DetailTreeEditComponent = (function () {
    function DetailTreeEditComponent() {
        this.bindings = treeEditBind;
        this.templateUrl = 'detail-tree-edit.html';
        this.controller = DetailTreeEditController;
    }
    return DetailTreeEditComponent;
}());
angular
    .module('application')
    .component('detailTreeEditSection', new DetailTreeEditComponent());

//# sourceMappingURL=detail.tree.edit.component.js.map
